import axios from "axios";

const getGenerateProgress = (uuid) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`/serialnumber/api/v1/serialnumber/generate/${uuid}/progress`)
      .then((response) => resolve(response.data))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

export default getGenerateProgress;
